// extracted by mini-css-extract-plugin
export var addressFields = "_ka-0";
export var animationContainer = "_ka-1";
export var footer = "_ka-2";
export var lineItems = "_ka-3";
export var modalContent = "_ka-4";
export var orderName = "_ka-5";
export var strong = "_ka-6";
export var warning = "_ka-7";